import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DynamicModalService } from '../../../../../core/services/dynamic-modal.service';
import { AuditService } from '../../../../../core/services/audit.service';
import { Audit } from '../../../../../core/interfaces/audit.interface';

type AuditValue = string | number | boolean | Record<string, unknown> | null;
type AuditModalData = Partial<Omit<Audit, 'oldvalue' | 'newvalue'>> & {
  id?: number | string;
  oldvalue?: AuditValue;
  newvalue?: AuditValue;
};

@Component({
  selector: 'app-change-audit-modal',
  templateUrl: './change-audit-modal.component.html',
  styleUrls: ['./change-audit-modal.component.scss'],
})
export class ChangeAuditModalComponent implements OnInit {
  data: AuditModalData = {};
  oldValueIsObject: boolean = false;
  newValueIsObject: boolean = false;
  isLoading: boolean = true;

  constructor(
    public activeModal: NgbActiveModal,
    private dynamicModalService: DynamicModalService,
    private auditService: AuditService
  ) {}

  ngOnInit(): void {
    const modalData = this.dynamicModalService.getModalData() as
      | { data?: AuditModalData }
      | undefined;
    this.data = modalData?.data ?? {};
    this.loadAuditDetail();
  }

  loadAuditDetail(): void {
    if (!this.data?.id) {
      this.showData();
      this.isLoading = false;
      return;
    }

    this.auditService.getAuditDetail(this.data.id).subscribe({
      next: (response) => {
        this.data = {
          ...this.data,
          ...response?.data,
        };
        this.showData();
        this.isLoading = false;
      },
      error: () => {
        this.showData();
        this.isLoading = false;
      },
    });
  }

  showData(): void {
    try {
      if (typeof this.data.newvalue === 'string') {
        this.data.newvalue = JSON.parse(this.data.newvalue) as AuditValue;
      }
    } catch (_error) {}
    try {
      if (typeof this.data.oldvalue === 'string') {
        this.data.oldvalue = JSON.parse(this.data.oldvalue) as AuditValue;
      }
    } catch (_error) {}
    this.newValueIsObject =
      typeof this.data.newvalue === 'object' && this.data.newvalue !== null;
    this.oldValueIsObject =
      typeof this.data.oldvalue === 'object' && this.data.oldvalue !== null;
  }
}
